import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import AuthRoute from 'app/components/shared/AuthRoute';
import { adminRoutes, routes } from 'app/constants/routes';
import LoadingScreen from 'app/pages/shared/LoadingScreen';
import { retry } from 'app/utils/lib/file';

import AdminRoutesLayout from '../../Layouts/AdminRoutesLayout';

// Lazy-loaded route components
const LazyFourOhFourRoute = lazy(() => retry(() => import('app/pages/error/FourOhFour')));

// Component wrapper types
type ComponentProps = Record<string, unknown>;

// DefaultRedirect component
const defaultPath = `/${routes.admin}/${adminRoutes.dashboard}`;
export const DefaultRedirect = () => <Navigate to={defaultPath} />;

// FourOhFour component
export const FourOhFour = (props: ComponentProps) => <LazyFourOhFourRoute {...props} />;

// AdminLayout component
export const AdminLayout = () => {
  return (
    <AuthRoute adminOnly>
      <AdminRoutesLayout
        body={(
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        )}
      />
    </AuthRoute>
  );
};
